import { IconArrowRight16 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackAnswerQuestionsClick } from './tracking';
import { openChatbotFiltersModal } from '../../actions/chatbotFiltersModal';
import { ChatbotButton } from '../../components/ChatbotButton';

export const AnswerQuestionsButtonContainer: React.FC = () => {
  const dispatch = useDispatch();

  const onClick = React.useCallback(() => {
    trackAnswerQuestionsClick();
    dispatch(openChatbotFiltersModal());
  }, [dispatch]);

  return (
    <ChatbotButton onClick={onClick} theme="fill_white_primary" afterIcon={<IconArrowRight16 color="primary_100" />}>
      Ответить на&#x00a0;вопросы
    </ChatbotButton>
  );
};
